module.exports = "<ul>\n    <li (click)=\"togglePictureAuth()\">{{ 'picture-auth.text' | translate }}</li>\n    <li (click)=\"reportAbuse()\">{{ 'chat.report-abuse' | translate }}</li>\n    <li (click)=\"deleteContact()\">{{ 'chat.delete-contact' | translate }}</li>\n</ul>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/chat/chat-actions.component.html
// module id = 475
// module chunks = 0